import { MissionCardProps } from '../../MissionCard/MissionCard'
import styles from '../../MissionCard/MissionCard.module.scss'

interface Props {
  missionCard: MissionCardProps
}
const ReceiptReviewMasterMissionCardGuide = ({ missionCard }: Props) => {
  const missionCardGroup = missionCard.missionCardGroup

  if (!missionCardGroup) return null

  return (
    <>
      미션 단계 별로 포인트가 각각 지급됩니다.
      <ul className={styles.desc_list}>
        {missionCardGroup.map((mission, index) => (
          <li key={mission.id} className={styles.list_item}>
            <em>{index + 1}단계</em> {mission.reward.name}
          </li>
        ))}
      </ul>
    </>
  )
}

export default ReceiptReviewMasterMissionCardGuide
